import React from 'react'
import { Route, Routes } from 'react-router-dom'

import HomePage from '../../pages/HomePage'

import BasicNameNumberCalculator from '../../pages/BasicNameNumberCalculator'
import BasicJanmankCalculator from '../../pages/BasicJanmankCalculator'
import BasicDomainNameNumberCalculator from '../../pages/BasicDomainNameNumberCalculator'

import FourOhFourPage from '../../pages/FourOhFourPage'

const RoutHub = () => {
  return (
    <Routes>

        <Route path='/' element={<HomePage />} />

        <Route path='/tools/basic-name-number-calculator' element={<BasicNameNumberCalculator />} />
        <Route path='/tools/basic-janmank-calculator' element={<BasicJanmankCalculator />} />
        <Route path='/tools/basic-domain-name-number-calculator' element={<BasicDomainNameNumberCalculator />} />

        <Route path='*' element={<FourOhFourPage />} />

    </Routes>
  )
}

export default RoutHub